// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#myImg {
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  .modal-body-calculator{
    width: 405px;
    background-color: #edeced;
  }

  .isOpenZoom{
    display: block !important;
    z-index: 99999 !important;
  }
  
  #myImg:hover {opacity: 0.7;}
  
  #modalzoom {
    display: none;
    position: fixed;
    z-index: 1; 
    padding-top: 100px; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background-color: rgb(0,0,0); 
    background-color: rgba(0,0,0,0.9); 
  }
  
  /* Modal Content (image) */
  #imgzoom {
    /*height: 95%;
    width: auto;*/
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 15px;
    max-width: 100%;
  }
  
  #caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
  }
  
  #imgzoom, #caption {  
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
  }
  
  @keyframes zoom {
    from {transform:scale(0)} 
    to {transform:scale(1)}
  }
  
  .isOpenZoom .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: white;
    font-size: 50px;
    font-weight: bold;
    transition: 0.3s;
    z-index:999999 !important;
    opacity:1;
  }
  
  #imgzoom .close:hover,
  #imgzoom .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }
  
  @media only screen and (max-width: 700px){
    #imgzoom  {
      width: 100%;
    }
  }

  .iframe-html {
    height: 439px;
    width: 100%;
  }`, "",{"version":3,"sources":["webpack://./src/app/components/tool-kit/tool-kit.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA,cAAc,YAAY,CAAC;;EAE3B;IACE,aAAa;IACb,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA,0BAA0B;EAC1B;IACE;iBACa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;IAChC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAOA;IACE,MAAM,kBAAkB;IACxB,IAAI,kBAAkB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE;MACE,WAAW;IACb;EACF;;EAEA;IACE,aAAa;IACb,WAAW;EACb","sourcesContent":["#myImg {\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: 0.3s;\r\n  }\r\n  .modal-body-calculator{\r\n    width: 405px;\r\n    background-color: #edeced;\r\n  }\r\n\r\n  .isOpenZoom{\r\n    display: block !important;\r\n    z-index: 99999 !important;\r\n  }\r\n  \r\n  #myImg:hover {opacity: 0.7;}\r\n  \r\n  #modalzoom {\r\n    display: none;\r\n    position: fixed;\r\n    z-index: 1; \r\n    padding-top: 100px; \r\n    left: 0;\r\n    top: 0;\r\n    width: 100%; \r\n    height: 100%; \r\n    overflow: auto; \r\n    background-color: rgb(0,0,0); \r\n    background-color: rgba(0,0,0,0.9); \r\n  }\r\n  \r\n  /* Modal Content (image) */\r\n  #imgzoom {\r\n    /*height: 95%;\r\n    width: auto;*/\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    padding-top: 15px;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  #caption {\r\n    margin: auto;\r\n    display: block;\r\n    width: 80%;\r\n    max-width: 700px;\r\n    text-align: center;\r\n    color: #ccc;\r\n    padding: 10px 0;\r\n    height: 150px;\r\n  }\r\n  \r\n  #imgzoom, #caption {  \r\n    -webkit-animation-name: zoom;\r\n    -webkit-animation-duration: 0.6s;\r\n    animation-name: zoom;\r\n    animation-duration: 0.6s;\r\n  }\r\n  \r\n  @-webkit-keyframes zoom {\r\n    from {-webkit-transform:scale(0)} \r\n    to {-webkit-transform:scale(1)}\r\n  }\r\n  \r\n  @keyframes zoom {\r\n    from {transform:scale(0)} \r\n    to {transform:scale(1)}\r\n  }\r\n  \r\n  .isOpenZoom .close {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 35px;\r\n    color: white;\r\n    font-size: 50px;\r\n    font-weight: bold;\r\n    transition: 0.3s;\r\n    z-index:999999 !important;\r\n    opacity:1;\r\n  }\r\n  \r\n  #imgzoom .close:hover,\r\n  #imgzoom .close:focus {\r\n    color: #bbb;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  @media only screen and (max-width: 700px){\r\n    #imgzoom  {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .iframe-html {\r\n    height: 439px;\r\n    width: 100%;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
